<script>
import options from "./HistoricFundPrices.options"
export default options
</script>

<template>
    <div v-if="isError && !hideError" class="">
        <article class="nyk-context-banner">
            <div class="nyk-context-banner__content">
                <div class="nyk-context-banner__content__info">
                    <p class="nyk-context-banner__content__info__description">
                        {{ errorMessage }}
                    </p>
                </div>
            </div>
            <button class="nyk-context-banner__link" v-on:click="handleHideSystemErrorMessage"></button>
        </article>
    </div>

    <Form class="nyk-historic-fund-prices--form">
        <NykDateTimePicker
            v-model="values.date"
            name="date"
            label="Vælg dato"
            maxDate="today"
            :predefinedValue="values.date"
            :disable="[(date) => date.getDay() === 0 || date.getDay() === 6]"
        />
    </Form>

    <!-- Desktop -->
    <DynamicTable
        v-if="!isMobile"
        :headers="headers" 
        :rows="rows" />

    <!-- Mobile -->
    <template v-if="isMobile">
        <h2>{{ isin }} {{ name }}</h2>
        <DynamicTable
            v-for="(table, i) in mobileTableGroups"
            :headers="table.header"
            :rows="table.rows" />
    </template>

    <!-- No data -->
    <template v-if="rows.length == 0">
        <p class="nyk-historic-fund-prices__data-error">{{ labelsError.noDataError }}</p>
    </template>
</template>